import { useAuthContext } from "src/auth/hooks";

const { Typography } = require("@mui/material");
const { useTheme } = require("@emotion/react");

// ======================================================================================================

export const CompanyName = ({ sx, ...other }) => {

  const theme = useTheme();

  const { user } = useAuthContext();

  return (
    <Typography
      variant="h4"
      color={theme.vars.palette.primary.main}
      sx={{
        whiteSpace: 'nowrap',       // Prevents wrapping
        overflow: 'hidden',        // Hides overflowing text
        textOverflow: 'ellipsis',  // Adds "..." for truncated text
        maxWidth: '100%',          // Ensures it respects container width
        ...sx,
      }}
      {...other}
    >
      {user?.CompanyName}
    </Typography>
  )
}

// ======================================================================================================

export const CompanyNameSmall = ({ sx, ...other }) => {

  const theme = useTheme();

  const { user } = useAuthContext();

  return (
    <Typography
      variant='button'
      fontWeight='bold'
      color={theme.vars.palette.primary.main}
      sx={{
        whiteSpace: 'nowrap',       // Prevents wrapping
        overflow: 'hidden',        // Hides overflowing text
        textOverflow: 'ellipsis',  // Adds "..." for truncated text
        maxWidth: '100%',          // Ensures it respects container width
        ...sx,
      }}
      {...other}
    >
      {user?.CompanyName}
    </Typography>
  )
}